import {gql} from 'apollo-angular';

export const GET_GAME_CATEGORIES_STUDENT = gql`
  query GetGameCategoriesStudent($clientId: String!, $gameType: GameType!) {
    getGameCategoriesStudent(clientID: $clientId, gameType: $gameType) {
      id
      name
      multiplier
      isActive
      isSelected
      isQuestOfMonth
      scoreType
      completePoints
      totalPoints
      completeEntries
      totalEntries
      progress {
        id
        gameType
        roundNumber
        highscore
      }
    }
  }
`;
